module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    purple: {
                        50: '#f1eff6',
                        // 100: '#d4cce2',
                        // 200: '#bfb4d5',
                        // 300: '#a191c1',
                        // 400: '#8f7cb5',
                        500: '#735ba3',
                        600: '#695394',
                        // 700: '#524174',
                        800: '#3f325a',
                        // 900: '#302644'
                    },
                    cyan: {
                        50: '#ebfbfa',
                        // 100: '#c0f3f1',
                        // 200: '#a2edea',
                        // 300: '#77e4d0',
                        // 400: '#5dfdda',
                        500: '#34d7d1',
                        600: '#2fc4be',
                        // 700: '#259994',
                        800: '#1d7673',
                        // 900: '#165a58',
                    },
                    orange: {
                        50: '#fff7eb',
                        // 100: '#fee7c0',
                        // 200: '#fedba1',
                        // 300: '#fdca76',
                        // 400: '#fdc05c',
                        500: '#fcb033',
                        600: '#e5a02e',
                        // 700: '#b37d24',
                        800: '#8b611c',
                        // 900: '#6a4a15',
                    },
                },
            },
        },
        fontFamily: {
            roboto: ['Roboto', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
    ],
};
